import * as bizComponents from './components';
import * as bizUtils from './@utils';
import * as bizHooks from './hooks';
import * as bizBaseComponents from './baseComponents';

export { bizUtils, bizHooks, bizComponents, bizServices, bizBaseComponents };

import {
    saveComment,
    commentSaveErrHandle,
    downloadFileByOpenWindow,
    DOWNLOAD_TYPE,
    AudioPlayer,
    getMessageContent,
    report,
    UndoRedo,
    SubmissionTime,
    shareToClassService,
    referSourceService,
    RangeSlider,
    productionLog,
    OpenApp,
    UmuHistory,
    historySim,
    playerManager,
    withNotification,
    PARTICIPATE_STATUS_TEXT,
    eventEmitter,
    Page,
    WxShare,
    BaseShare,
    DingdingShare,
    share,
    getShareIcon,
    getDefaultSessionDesc,
    getDefaultSessionTitle,
    follow,
    commit,
    checkFollowUmu,
    getFollowUrl,
    onAppShareClick,
    shareImgForApp,
    Uploader,
    upload,
    expandAccept,
    expandMediaAccept,
    getUploadResult,
    initWebview,
    toggleAppNavBar,
    sendMsgToApp,
    initMsgToApp,
    FAIL_STATUS,
    SUCCESS_STATUS,
    watchPayResult,
    pay,
    takeOrder,
    baseLogger,
    log,
    logSearch4,
    setSearch4BizTagType,
    getSectionListById,
    getExtraOptionId,
    buildSectionResult,
    getResultListState,
    getSubmitResult,
    getErrorTip,
    validSection,
    combineSectionListWithUserValue,
    combineSectionListWithStatResult,
    transformSectionList,
    isMergeOptionQuestionRight,
    isOldQuiz,
    getInputQuestionScoreRank,
    getTextQuestionScoreRank,
    getInputQuestionUserAnswer,
    getRightAnswerValue,
    getRightAnswer,
    getUserAnswer,
    getQuizAnswerResult,
    getUserQuizResult,
    SCORE_RANK,
    redirectToPaidUrl,
    checkEnterpriseAdminPermission,
    redirectToHome,
    redirectToNonWxPayment,
    redirectToCommericalTrial,
    getPlatform,
    redirectToContractSales,
    redirectToCommericalHome,
    redirectToProfessionalHome,
    redirectToPlan,
    redirectToPricing,
    redirectToPurchasePeriodPaymentPayment,
    getPurchasePeriodPaymentUrl,
    redirectToPurchaseAccountQuotaPayment,
    getPurchaseAccountQuotaPaymentUrl,
    redirectToPurchasePayment,
    PAYMENT_HISTORY_URL,
    INDEX_PAGE,
    accountDataService,
    REGISTER_BY,
    validateLoginName,
    validatePhone,
    validateMail,
    validatePswd,
    validateNewRulePswd,
    langSwitchList,
    getCurrentLang,
    getCurrentLangValue,
    setSiteLang,
    storageCurrentUserId,
    getUserInfo,
    isEnterpriseUser,
    isEnterpriseAccount,
    isRegisterUser,
    getLoginUrl,
    RECAPTCHA_SITE_KEY,
    PageSlider,
    setEnterpriseInviteStatus,
    PageVisibility,
    goUserProfile,
    isBasicVersion,
    isProfessionalVersion,
} from './services';

const bizServices = {
    downloadFileByOpenWindow,
    DOWNLOAD_TYPE,
    AudioPlayer,
    getMessageContent,
    report,
    SubmissionTime,
    shareToClassService,
    referSourceService,
    RangeSlider,
    productionLog,
    OpenApp,
    UmuHistory,
    historySim,
    playerManager,
    withNotification,
    PARTICIPATE_STATUS_TEXT,
    eventEmitter,
    Page,
    WxShare,
    BaseShare,
    DingdingShare,
    share,
    getShareIcon,
    getDefaultSessionDesc,
    getDefaultSessionTitle,
    follow,
    commit,
    checkFollowUmu,
    getFollowUrl,
    onAppShareClick,
    shareImgForApp,
    Uploader,
    upload,
    expandAccept,
    expandMediaAccept,
    getUploadResult,
    initWebview,
    toggleAppNavBar,
    sendMsgToApp,
    initMsgToApp,
    // SendMsgType,
    // TOOGLE_TYPE,
    FAIL_STATUS,
    SUCCESS_STATUS,
    watchPayResult,
    pay,
    takeOrder,
    baseLogger,
    log,
    logSearch4,
    setSearch4BizTagType,
    getSectionListById,
    getExtraOptionId,
    buildSectionResult,
    getResultListState,
    getSubmitResult,
    getErrorTip,
    validSection,
    combineSectionListWithUserValue,
    combineSectionListWithStatResult,
    transformSectionList,
    isMergeOptionQuestionRight,
    isOldQuiz,
    getInputQuestionScoreRank,
    getTextQuestionScoreRank,
    getInputQuestionUserAnswer,
    getRightAnswerValue,
    getRightAnswer,
    getUserAnswer,
    getQuizAnswerResult,
    getUserQuizResult,
    SCORE_RANK,
    redirectToPaidUrl,
    checkEnterpriseAdminPermission,
    redirectToHome,
    redirectToNonWxPayment,
    redirectToCommericalTrial,
    getPlatform,
    redirectToContractSales,
    redirectToCommericalHome,
    redirectToProfessionalHome,
    redirectToPlan,
    redirectToPricing,
    redirectToPurchasePeriodPaymentPayment,
    getPurchasePeriodPaymentUrl,
    redirectToPurchaseAccountQuotaPayment,
    getPurchaseAccountQuotaPaymentUrl,
    redirectToPurchasePayment,
    PAYMENT_HISTORY_URL,
    INDEX_PAGE,
    accountDataService,
    REGISTER_BY,
    validateLoginName,
    validatePhone,
    validateMail,
    validatePswd,
    validateNewRulePswd,
    langSwitchList,
    getCurrentLang,
    getCurrentLangValue,
    setSiteLang,
    storageCurrentUserId,
    getUserInfo,
    isEnterpriseUser,
    isEnterpriseAccount,
    isRegisterUser,
    getLoginUrl,
    RECAPTCHA_SITE_KEY,
    saveComment,
    commentSaveErrHandle,
    setEnterpriseInviteStatus,
    PageVisibility,
    goUserProfile,
    isBasicVersion,
    isProfessionalVersion,
};

// export { initHeader } from './services/commonHeader';

export { UndoRedo, PageSlider, RangeSlider };

import { AudioPlayer as AudioPlayerComp } from './components';
export { AudioPlayerComp };

/// ================ Services Exported Interface ================ ///
// import { ISliderOptions } from './services/pageSlider';
// export type { ISliderOptions as IPageSliderOptions };
import { ISliderOptions as IPageSliderOptionsOrigin } from './services/pageSlider';
export type IPageSliderOptions = IPageSliderOptionsOrigin;

import { ISendMsgToWebData as ISendMsgToWebDataOrigin } from './services/webview/sengMsgToWeb';
export type ISendMsgToWebData = ISendMsgToWebDataOrigin;

import { ISliderOptions as IRangeSliderOptionsOrigin } from './services/rangeSlider';
export type IRangeSliderOptions = IRangeSliderOptionsOrigin;

import { INotificationComponentProps as INotificationComponentPropsOrigin } from './services/notification';
export type INotificationComponentProps = INotificationComponentPropsOrigin;

import { IImMessageData as IImMessageDataOrigin } from './services/@imMsgService/imMsgService';
export type IImMessageData = IImMessageDataOrigin;

import { IInitMsgToAppData as IInitMsgToAppDataOrigin } from './services/webview/sengMsgToApp';
export type IInitMsgToAppData = IInitMsgToAppDataOrigin;

import { IAssessmentUserRecordParams as IAssessmentUserRecordParamsOrigin } from './services/downloadFileService';
export type IAssessmentUserRecordParams = IAssessmentUserRecordParamsOrigin;

import { IUndoRedoSnapshot as IUndoRedoSnapshotOrigin } from './services/undoRedo';
export type IUndoRedoSnapshot<T> = IUndoRedoSnapshotOrigin<T>;

import { IChangeCallbackArgs as IChangeCallbackArgsOrigin } from './components/account/@phoneInput/phoneInput';
export type IChangeCallbackArgs = IChangeCallbackArgsOrigin;

/// ================ BaseComponent Exported Interface ================ ///
import { IBaseProps, IBaseState } from './baseComponents/basePageSliderPage/basePageSliderPage';
export type IBasePageSliderPageBaseProps<T> = IBaseProps<T>;
export type IBasePageSliderPageBaseState = IBaseState;

/// ================ Component Exported Interface ================ ///
import { IAiReportData as IAiReportDataOrigin } from '@umu/umu-types/src/interface/aiReportInfo';
export type IAiReportData = IAiReportDataOrigin;

import { IProps as IMoreTextProps_ } from './components/moreText/moreText';
export type IMoreTextProps = IMoreTextProps_;

import {
    IProps as ISectionNumberProps_,
    IState as ISectionNumberState_,
} from './components/@sectionList/@sectionItem/sectionTypes/@sectionNumber/sectionNumber';
export type ISectionNumberProps<T1, T2, T3> = ISectionNumberProps_<T1, T2, T3>;
export type ISectionNumberState = ISectionNumberState_;

import { IGridItem as IGridItem_ } from './components/@transformersGrid/transformersGrid';
export type IGridItem = IGridItem_;
export { SearchInput } from './components/searchInput';
export { onBatchAddAccountDialog, BatchAddAccount, TransformInput } from './components/searchInput/components/batchAddAccount';
import {
    IProps as IDocNoteComposerProps_,
    IState as IDocNoteComposerState_,
} from './components/@docNoteComposer/docNoteComposer';
export type IDocNoteComposerProps = IDocNoteComposerProps_;
export type IDocNoteComposerState = IDocNoteComposerState_;

import {
    IDraftCommentInfo as IMicroCourseNoteComposerDraftCommentInfo_,
    IProps as IMicroCourseNoteComposerProps_,
    IState as IMicroCourseNoteComposerState_,
    ISubmitData as IMicroCourseNoteComposerDraftSubmitData_,
} from './components/@microCourseNoteComposer/microCourseNoteComposer';
export type IMicroCourseNoteComposerDraftCommentInfo = IMicroCourseNoteComposerDraftCommentInfo_;
export type IMicroCourseNoteComposerProps = IMicroCourseNoteComposerProps_;
export type IMicroCourseNoteComposerState = IMicroCourseNoteComposerState_;
export type IMicroCourseNoteComposerSubmitData = IMicroCourseNoteComposerDraftSubmitData_;

import {
    IProps as IFormCheckboxListProps_,
    IState as IFormCheckboxListState_,
} from './components/@sectionList/@sectionItem/sectionTypes/@formCheckboxList/formCheckboxList';
export type IFormCheckboxListProps = IFormCheckboxListProps_;
export type IFormCheckboxListState = IFormCheckboxListState_;

import {
    IProps as ISectionTextareaProps_,
    IState as ISectionTextareaState_,
} from './components/@sectionList/@sectionItem/sectionTypes/@sectionTextarea/sectionTextarea';
export type ISectionTextareaProps<T, T1, T2> = ISectionTextareaProps_<T, T1, T2>;
export type ISectionTextareaState = ISectionTextareaState_;

import {
    IProps as IFormRadioboxListProps_,
    IState as IFormRadioboxListState_,
} from './components/@sectionList/@sectionItem/sectionTypes/@formRadioboxList/formRadioboxList';
export type IFormRadioboxListProps<T1, T2, T3> = IFormRadioboxListProps_<T1, T2, T3>;

export type IFormRadioboxListState = IFormRadioboxListState_;

export  type {IUCourseShareData} from './components/@uCourseShareCard'
export {EShareCardType} from './components/@uCourseShareCard'
